// src/services/clientDetails.ts
//
// Client-details-domain service. Backs the client detail page tabs: profile,
// nutrition stats, assigned meal data, daily logs (water/sleep/exercise/etc),
// weight chart, weekly insights, recipes and ingredient lookup.

import { apiFetch } from "../Component/api/apiFetch";
import { API_URLS } from "../Component/api/url";
import { handleJson } from "./http";

export const getUserProfileDetails = (userId: string | number): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_USER_PROFILE_DETAILS(userId), { method: "GET" })
  );

export const getNutritionStats = (
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_NUTRITION_STATS, {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const getAssignMealData = (
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_ASSIGN_MEAL_DATA, {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const getAllLogsDetails = (
  userId: string | number,
  date: string | number
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_ALLLOGS_DETAILS(userId, date), { method: "GET" })
  );

export const getWeightChartData = (userId: string): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_WEIGHT_CHART_DATA(userId), { method: "GET" })
  );

export const getInsightsWeeklyData = (
  userId: string | number,
  referenceDate: string
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_INSIGHTS_WEEKLY_DATA(userId, referenceDate), {
      method: "GET",
    })
  );

export const getInsightsFortnightlyData = (
  userId: string | number,
  referenceDate: string
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_INSIGHTS_FORTNIGHTLY_DATA(userId, referenceDate), {
      method: "GET",
    })
  );

export const getInsightsMonthlyData = (
  userId: string | number,
  referenceDate: string
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_INSIGHTS_MONTHLY_DATA(userId, referenceDate), {
      method: "GET",
    })
  );

export const getRecipeList = (
  userId: string | number,
  page: number,
  size: number,
  search: string = ""
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_RECIPE_LIST(userId, page, size, search), {
      method: "GET",
    })
  );

export const getIngredientList = (
  recipeId: string | number,
  search: string = ""
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_INGREDIENT_LIST(recipeId, search), { method: "GET" })
  );
